/**
 * Created by rathompson on 9/28/21
 * File: TypeRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useMemo } from 'react'
import { Tooltip } from '@panwds/react-ui'
import { UserIcon, UsersIcon, NetworkWiredIcon } from '@panwds/icons'
import { IDENTITY_TYPES, LABEL_USER, LABEL_GROUP, LABEL_SERVICE_ACCOUNT } from '../../../../constants/IAMConstants'
import { ARRAY } from '../../../../../common/utils/Utils'

/**
 *   Identity type table cell
 */
const TypeRenderer = ({ row, value }) => {


  const Icon = useMemo(() => {
    switch (value) {
      case IDENTITY_TYPES.SERVICE_ACCOUNT:
        return NetworkWiredIcon
      case IDENTITY_TYPES.GROUP:
        return UsersIcon
      case IDENTITY_TYPES.USER:
      default:
        return UserIcon
    }
  }, [value])

  const label = useMemo(() => {
    switch (value) {
      case IDENTITY_TYPES.SERVICE_ACCOUNT:
        return LABEL_SERVICE_ACCOUNT
      case IDENTITY_TYPES.GROUP:
        return LABEL_GROUP
      case IDENTITY_TYPES.USER:
      default:
        return LABEL_USER
    }
  }, [value])

  const className = useMemo(() => {
    const { apps, inherited_from, policies, roles } = row?.original || {}
    if (ARRAY.hasArray(apps) && apps.length > 1) {
      return 'tw-pt-2'
    }
    if (ARRAY.hasArray(inherited_from) && inherited_from.length > 1) {
      return 'tw-pt-2'
    }
    if (ARRAY.hasArray(policies) && policies.length > 1) {
      return 'tw-pt-2'
    }
    if (ARRAY.hasArray(roles) && roles.length > 1) {
      return 'tw-pt-2'
    }
    return 'tw-place-self-center'
  }, [row?.original])

  return (
    <div className='tw-flex tw-w-full tw-h-full'>
      <div className={className}>
        <Tooltip label={label}>
          <Icon size='sm' />
        </Tooltip>
      </div>
    </div>
  )
}

TypeRenderer.propTypes = {}
export default TypeRenderer
